import { Component } from '@angular/core';
import {BreadcrumbMktComponent} from "../breadcrumb-mkt/breadcrumb-mkt.component";

@Component({
  selector: 'app-dashboard-main',
  standalone: true,
    imports: [
        BreadcrumbMktComponent
    ],
  templateUrl: './dashboard-main.component.html',
  styleUrl: './dashboard-main.component.css'
})
export class DashboardMainComponent {

  title= 'Dashboard Main';
  route='/dashboardmkt/'

}
